/**
 * V162: workSchedule 관련 유틸리티 함수
 *
 * 목적:
 * - 대시보드와 근로일정 페이지 간 승인 판정 로직 통일
 * - 중복 코드 제거 및 유지보수성 향상
 */

import { WorkSchedule } from '../types/workSchedule';

/**
 * V162: 승인된 근로일정이 있는지 판단
 *
 * 판단 기준:
 * - workSchedule 문서가 존재하고 (null이 아님)
 * - base 필드가 정의되어 있으면 → 승인된 근로일정 있음
 *
 * 사용처:
 * - WorkMyDashboardPage: 출근 버튼 활성화 조건
 * - WorkSchedulePage: 캘린더 색상 (approved)
 *
 * @param workSchedule - workSchedule 문서 (null 가능)
 * @returns 승인된 근로일정 존재 여부
 */
export function hasApprovedWorkSchedule(workSchedule: WorkSchedule | null | undefined): boolean {
  return workSchedule !== null && workSchedule !== undefined && workSchedule.base !== undefined;
}

/**
 * V162: 월 문자열 생성 (YYYY-MM 형식)
 *
 * @param year - 년도
 * @param month - 월 (1-12)
 * @returns YYYY-MM 형식 문자열
 */
export function formatMonthString(year: number, month: number): string {
  return `${year}-${String(month).padStart(2, '0')}`;
}

/**
 * V162: Date 객체에서 월 문자열 생성
 *
 * @param date - Date 객체
 * @returns YYYY-MM 형식 문자열
 */
export function formatMonthFromDate(date: Date): string {
  return formatMonthString(date.getFullYear(), date.getMonth() + 1);
}

/**
 * V162: 현재 월 문자열 생성
 *
 * @returns 현재 월의 YYYY-MM 형식 문자열
 */
export function getCurrentMonthString(): string {
  const now = new Date();
  return formatMonthString(now.getFullYear(), now.getMonth() + 1);
}
